
import { Separator } from '@/components/ui/separator';
import { formatCurrency } from '@/lib/utils';

interface Deduction {
  id: string;
  name: string;
  amount: number;
  value?: string;
}

interface DeductionsBreakdownProps {
  deductions: Deduction[];
  totalDeductions: number;
}

export const DeductionsBreakdown = ({ deductions, totalDeductions }: DeductionsBreakdownProps) => {
  const hasDeductions = deductions && deductions.length > 0;
  
  return (
    <div className="p-6 border b border-gray-400 my-2 rounded-md">
      <h3 className="font-semibold text-lg mb-3">Deductions</h3>
      <div className="space-y-2">
        {/* Deduction items */}
        {hasDeductions ? (
          deductions.map(deduction => (
            <div key={deduction.id} className="flex justify-between py-1 px-3 rounded-sm">
              <span className="pr-4">{deduction.name}</span>
              <span className="text-red-600">{deduction.value ? deduction.value : `-${formatCurrency(deduction.amount)}`}</span>
            </div>
          ))
        ) : (
          <div className="text-sm text-gray-500 italic">
            No deductions configured for this payslip
          </div>
        )}
        
        <Separator />
        <div className="flex justify-between font-semibold py-1 px-2 rounded-sm">
          <span>Total Deductions</span>
          <span className="text-red-600">-{formatCurrency(totalDeductions)}</span>
        </div>
        
        {/* Show calculation breakdown if no deductions */}
        {!hasDeductions && totalDeductions === 0 && (
          <div className="text-xs text-gray-500 mt-2 p-2 bg-gray-50 rounded">
            <div className="font-medium mb-1">Note:</div>
            <div>No deductions have been applied to this payslip.</div>
            <div>Deductions may include: NAPSA, PAYE, Advances, Loans, etc.</div>
          </div>
        )}
      </div>
    </div>
  );
};
